import layout1 from './layout1/Layout1';
import layoutMarketing from './layout-marketing/LayoutMarketing';
import layoutMarketingQuill from './layout-marketing/LayoutMarketingQuill';
import layoutMarketingV2 from './layout-marketing-v2/LayoutMarketingV2';

const themeLayouts = {
  layout1,
  layoutMarketing,
  layoutMarketingQuill,
  layoutMarketingV2
};

export default themeLayouts;
